import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import useAxios from 'axios-hooks';
import { format, subDays } from 'date-fns';
import isEmpty from 'lodash.isempty';

import { API_URL } from '../../../config/constants';
import { Button } from '../../../components';
import { short, long } from '../common/formatting/date';

const RPMModal = ({
	isOpen,
	onClose,
	notificationResponse,
	providerId,
	practice,
}) => {
	let [{ data, loading: dataLoading /* error */ }, loadRPMDetailData] =
		useAxios(
			{
				url: `/providers/${providerId}/vital-tracker-dashboard-patient-detail`,
			},
			{ manual: true }
		);

	useEffect(() => {
		if (isOpen && notificationResponse) {
			const date_end = format(
				new Date(notificationResponse.vital_dttm),
				'yyyy-MM-dd'
			);
			const params = {
				patient_id: notificationResponse.patientId,
				date_start: format(
					subDays(new Date(notificationResponse.vital_dttm), 1),
					'yyyy-MM-dd'
				),
				date_end,
				vitalTypes: [notificationResponse.vital_name],
			};
			loadRPMDetailData({ params });
		}
	}, [isOpen, notificationResponse]);

	const handlePrintClicked = () => {
		window.print();
	};

	return (
		<Modal
			isOpen={isOpen}
			contentLabel="Assessment"
			className="modal-dialog ackd-notification-rpm modal-xl"
			overlayClassName="overlay-temp"
		>
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={handlePrintClicked}>
								<em className="fa fa-print"></em>
							</button>
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">RPM Details</h3>
					</div>
				</div>
				<div className="modal-body">
					{isOpen && notificationResponse && (
						<div className="row">
							<div className="col-sm-4">
								{!isEmpty(practice.logo_image_name) && (
									<img
										src={`${API_URL}/provider_practice_logos/${practice.id}/download/${practice.logo_image_name}`}
										style={{
											width: '200px',
											height: 'auto',
											marginBottom: '1rem',
										}}
									/>
								)}
								<br />
								{practice.practice_name}
								<br />
								{practice.address1}
								<br />
								{!isEmpty(practice.address2) && (
									<React.Fragment>
										{practice.address2}
										<br />
									</React.Fragment>
								)}
								{practice.city} {practice.state} {practice.zip}
								<br />
							</div>
							<div className="col-sm-4">
								<dl className="dl-horizontal">
									<dt>Patient Name</dt>
									<dd>
										{notificationResponse.name_last},{' '}
										{notificationResponse.name_first}{' '}
										{!isEmpty(notificationResponse.gender)
											? `(${notificationResponse.gender})`
											: ''}
									</dd>
									<dt>Patient DOB</dt>
									<dd>{short(notificationResponse.birth_dttm)}</dd>
								</dl>
							</div>
							<div className="col-sm-4">
								<dl className="dl-horizontal">
									<dt>Responded By</dt>
									<dd>
										{!isEmpty(notificationResponse.provider_name_last)
											? `${notificationResponse.provider_name_first} ${notificationResponse.provider_name_last} ${notificationResponse.provider_credentials}`
											: null}
									</dd>
									<dt>Responded On</dt>
									<dd>
										{!isEmpty(notificationResponse.provider_response_dttm) &&
											long(notificationResponse.provider_response_dttm)}
									</dd>
									<dt>Response</dt>
									<dd>
										{isEmpty(notificationResponse.provider_response) ? (
											<em>No reponse given</em>
										) : (
											notificationResponse.provider_response
										)}
									</dd>
								</dl>
							</div>
						</div>
					)}
					{isOpen &&
						notificationResponse &&
						Array.isArray(data) &&
						!dataLoading && (
							<>
								<h4>{notificationResponse.vital_name}</h4>
								<table className="table table-striped">
									<thead>
										<tr>
											<th>Timestamp</th>
											<th>Unit</th>
											<th>Value</th>
											<th>Data Source</th>
										</tr>
									</thead>
									<tbody>
										{data.map((vital) => (
											<tr key={`${vital.vital_id}`}>
												<td>{long(vital.vital_dttm)}</td>
												<td>{vital.unit}</td>
												<td>{vital.value}</td>
												<td>{vital.data_source}</td>
											</tr>
										))}
									</tbody>
								</table>
							</>
						)}
				</div>
				<div className="modal-footer">
					<Button title="Close" onClick={onClose} large primary />
				</div>
			</div>
		</Modal>
	);
};

RPMModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	notificationResponse: PropTypes.object,
	providerId: PropTypes.number.isRequired,
	practice: PropTypes.object.isRequired,
};
export default RPMModal;
